'use client';

import blockContractFilters from '@/app/dashboard/contracts/block-contracts/filters';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  BlockContractConfig,
  type BlockContract,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const BlockContractItem: RelationFieldProps<BlockContract> = {
  nested: getRelationFieldNames(BlockContractConfig),
  filters: blockContractFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.idNumber,
    badge:
      item.status != null ? (
        <StatusBadge
          className='font-medium'
          status={item.status}
          type='contract'
        />
      ) : undefined,
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        <div className='font-medium'>
          {item.tenant?.communicationName ?? 'Ingen hyresgäst kopplad'}
        </div>
        {!isRelationField && <Dot />}
        <span> {item.customId ?? 'Inget objekts-id angivet'}</span>
      </div>
    ),
  }),
};
